import { render, staticRenderFns } from "./punkt-list-block.vue?vue&type=template&id=801a4af4"
import script from "./punkt-list-block.vue?vue&type=script&lang=ts"
export * from "./punkt-list-block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports